module.exports = __webpack_public_path__ + "static/media/social-icon-twitter.9f87ca36.svg";